import type { HTMLAttributes } from "react";

import clsx from "clsx";

import styles from "./spinner.module.css";

export function Spinner(props: HTMLAttributes<HTMLSpanElement>) {
	return (
		<span {...props} className={clsx(styles.spinner, props.className)} data-testid="spinner" />
	);
}
